export const AI_OCR_URL = '/invoice_upload/new';

export const PAYMENT_REQUEST_IMPORT_SUPPORT_URL =
  'https://biz.moneyforward.com/support/payable/guide/linkage-general/lg04.html';
